import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let pending = null;

// Demo sign-in details live on the server and are only sent in a demo environment.
export const loadDemoConfig = () => {
  if (!pending) {
    pending = fetch(`${API_URL}/api/demo/config`)
      .then((r) => (r.ok ? r.json() : { enabled: false }))
      .catch(() => ({ enabled: false }));
  }
  return pending;
};

export const useDemoConfig = () => {
  const [config, setConfig] = useState({ enabled: false });
  useEffect(() => {
    let live = true;
    loadDemoConfig().then((c) => { if (live) setConfig(c || { enabled: false }); });
    return () => { live = false; };
  }, []);
  return config;
};
